import { render, staticRenderFns } from "./DisplayedRowCountStatusBar.vue?vue&type=template&id=17799bfe"
import script from "./DisplayedRowCountStatusBar.vue?vue&type=script&lang=js"
export * from "./DisplayedRowCountStatusBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports